<!-- <textarea [disabled]="disabled" id="{{ elementId }}">{{ dataForm }}</textarea> -->
<div *ngIf="settings">
  <editor
    id="{{ elementId }}"
    [init]="settings"
    [(ngModel)]="dataForm"
    (onChange)="onChange($event)"
    (onBlur)="onBlur($event)"
    (onKeyUp)="onKeyUp($event)"
    (onSetContent)="onSetContent($event)"
    (onDirty)="onDirty($event)"
  ></editor>
</div>
